<template>
    <div>
        <template v-if="width < 2054 && width > 1699">
            <vs-row justify="flex-end">
                <vs-col :key="index" v-for="(col, index) in 3" w="2"><br /></vs-col>
            </vs-row>
        </template>
        <vx-card title="실별 스케줄">
            <div class="vx-row">
                <div class="vx-col w-full xl:w-1/1 mb-base text-center">
                    <vs-button color="dark" type="line" icon-pack="feather" icon="icon-arrow-left" @click="prevMonth"></vs-button>
                    <span class="ml-5 mr-5"
                        >{{ this.startDate }} ~ {{ this.endDate }}</span>
                    <vs-button color="dark" type="line" icon-pack="feather" icon="icon-arrow-right" @click="nextMonth"></vs-button>
                </div>
            </div>
            <vs-button type="line" v-bind:class="activeMenu('')" v-on:click="tabClick('')" v-show="tabShowAll">전체</vs-button>
            <vs-button type="line" v-for="(item, index) in tabList" :key="index" v-bind:class="activeMenu(item.TREATMENT_ROOM_ID)" v-on:click="tabClick(item.TREATMENT_ROOM_ID)">{{ item.TREATMENT_NAME }}</vs-button>
            <br /><br />
            <div>
                <span>* 해당 날짜에 시간 셀을 클릭하시면 환자를 등록할 수 있습니다.</span>
            </div>

             <div class="flex justify-end flex-wrap mb-3"> 
                <vs-button radius color="primary" icon-pack="feather" icon="icon-edit-2" @click="popupOpen('', '')" />
            </div> 

           <div class="tb_wrap">
            <div class="tb_box" id="calendarDiv" style="width:100%;overflow-x:auto;height:900px;">
                    <table id="schedule" class="border-collapse calendar" style="max-width:1200px; max-height:550px;">
                        <thead>
                            <tr class="fixed_top">
                                <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header" style="width:100px !important;">시간 / 일</th>
                                <th
                                    class="p-2 border border-solid d-theme-border-grey-light text-center table_header"
                                    :style="item.YMD.substring(8, 10) == nowDay ? 'background-color:#439798 !important; color:#fff;z-index:999;' : 'z-index:999;'"
                                    v-for="(item, index) in dateList"
                                    :key="index"
                                    v-bind:id="item.YMD"
                                >
                                    <div style="padding-bottom:5px;">
                                        <b style="font-size:12px;">{{ dayReturn(item.YMD) }}</b>
                                    </div>
                                    <div>
                                        <span v-for="(item2, index2) in newCountList" :key="index2" style="margin-top:10px;">
                                            <template v-if="item2.YMD == item.YMD && index2 != (index+1)*8-1" >
                                                {{ item2.TREATMENT_NAME}}({{ item2.TOTAL_COUNT }}) / 
                                            </template>
                                            <template v-else-if="item2.YMD == item.YMD && index2 == (index+1)*8-1">
                                                {{ item2.TREATMENT_NAME}}({{ item2.TOTAL_COUNT }}) 
                                            </template>
                                        </span>
                                    </div>
                                </th>
                            </tr>
                            <!-- 연차 행 (항상 표시, 헤더 아래 sticky) -->
                            <VacationRow
                                :date-list="dateList"
                                :vacation-map="vacationMap"
                                :date-key-format="formatDateKeyForVacation"
                                :sticky="true"
                                sticky-top="70px"
                                :show-full-name="true"
                            />
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in timeList" :key="index">
                                <th class="border border-solid d-theme-border-grey-light text-center table_header b-table-sticky-column timeHeader" style="" :id="item.CODE_TIME.substring(0, 2)">
                                    <span> {{ item.CODE_TIME.substring(0, 2) }}</span>
                                </th>
                                <td
                                    class="border border-solid d-theme-border-grey-light"
                                    style="min-width:700px;height:100px;vertical-align:top;padding:0px;"
                                    v-for="(item2, index2) in dateList" :key="index2"
                                    >
                                    <table class="contentTable" width="100%" cellspacing="0">
                                        <colgroup>
                                            <col width="50" />
                                            <col width="80" />
                                            <col width="20" />
                                            <col width="100" />
                                            <col width="200" />
                                            <col width="*" />
                                            <col width="100" />
                                        </colgroup>
                                        <thead>
                                            <tr>
                                                <th class="text-center headerBtn" colspan="7">
                                                    <vs-row vs-type="flex" vs-justify="center">
                                                        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
                                                            <a href="javascript:void(0)" @click="popupOpen(item2.YMD, item.CODE_TIME)">
                                                                <i class="vs-icon notranslate icon-scale feather icon-edit-2 null" style="order: 0; margin-right: 0px; margin-left: 0px;"></i>
                                                            </a>
                                                            <!-- <a href="javascript:void(0)" @click="clipCopyConfirm(item2.YMD, item.CODE_TIME)">
                                                                <i class="vs-icon notranslate icon-scale feather icon-copy null" style="order: 0; margin-right: 0px; margin-left: 0px;"></i>
                                                            </a> -->
                                                        </vs-col>
                                                    </vs-row>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item3, index3) in treatmentData" :key="index3" :style="styleReturn(item3.TREATMENT_NAME)">
                                                <template v-if="item2.YMD == (item3.YMD_STRING.substring(0,4) + '-' + item3.YMD_STRING.substring(4,6) + '-' + item3.YMD_STRING.substring(6,8))">
                                                    <template v-if="item.CODE_TIME.substring(0, 2) == item3.TIME_STRING.substring(0, 2)">
                                                        <td>
                                                            <input type="checkbox" v-model="copyChecked" :value="item3.SCHEDULE_SEQ" />
                                                        </td>
                                                        <td>{{ item3.TIME_STRING.substring(0, 2) }}:{{ item3.TIME_STRING.substring(2, 4) }}</td>
                                                        <td>[{{ item3.TREATMENT_NAME.substring(0, 1) }}]</td>
                                                        <td>
                                                            <a :href="'/patientSchedule/scheduleCalendar/' + item3.PATIENT_UID">
                                                                <template v-if="item3.DC == 'Y'">
                                                                    <span style="text-decoration:line-through"> {{ item3.MEDICAL_ROOM_NUMBER_NM }} {{ item3.PATIENT_USERNAME }}</span>
                                                                </template>
                                                                <template v-else>{{ item3.MEDICAL_ROOM_NUMBER_NM }} {{ item3.PATIENT_USERNAME }}</template>
                                                            </a>
                                                        </td>
                                                        <td>
                                                            <template v-if="item3.DC == 'Y'">
                                                                <span>{{ item3.DC_MEMO }}</span>
                                                            </template>
                                                            <template v-else>{{ item3.MANAGER_NAME.substring(0,1) }} / {{ item3.MEDICAL_DETAILS }} / {{ item3.MEMO }}</template>
                                                        </td>
                                                        <td>{{ item3.MAIN_MEMBER_NAME.substring(0, 1) }} / {{ item3.WEST_MEMBER_NAME.substring(0, 1) }}</td>
                                                        <td>
                                                            <a href="#" @click="onClickMemberView(item3.PATIENT_UID)">
                                                                <i class="vs-icon notranslate icon-scale  feather icon-search null" style="order: 0; margin-right: 0px; margin-left: 0px; color:#31C872;"></i>
                                                            </a>
                                                            &nbsp;
                                                            
                                                            <a href="#" @click="viewSchedule(item3.SCHEDULE_SEQ)">
                                                                <i class="vs-icon notranslate icon-scale feather icon-edit-2 null" style="order: 0; margin-right: 0px; margin-left: 0px;color:#015666;"></i>
                                                            </a>
                                                            &nbsp;
                                                            
                                                            <a href="javascript:void(0)" @click="checkDeleteSchedule(item3)">
                                                                <i class="vs-icon notranslate icon-scale  feather icon-x null" style="order: 0; margin-right: 0px; margin-left: 0px;color:red;"></i>
                                                            </a>
                                                        </td>
                                                    </template>
                                                </template>
                                            </tr>
                                        </tbody>
                                    </table> 
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div> 
        </vx-card>
        <vs-popup title="스케줄 등록 및 수정" :active.sync="popupActive">
            <form @submit.prevent>
                <div class="vx-row mb-3">
                    <div class="vx-col w-full lg:w-1/1">
                        <v-select :maxHeight="'50px'" v-model="selectedTabOption" @input="changeManagerDetailList" :options="tabOptions" :dir="$vs.rtl ? 'rtl' : 'ltr'"> </v-select>
                     </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col w-full lg:w-1/2 ">
                        <label for="" class="vs-select--label">날짜</label>
                        <datepicker name="uniquename" v-model="selectDate" placeholder="날짜선택" :format="customFormatter"></datepicker>
                    </div>
                    <div class="vx-col w-full lg:w-1/2">
                        <label for="" class="vs-select--label">시간(hhmm)-ex.0930</label>
                        <input
                            type="text"
                            class="w-full vs-inputx vs-input--input normal hasValue"
                            id="select_time"
                            name="select_time"
                            label="시간을 입력해주세요."
                            placeholder="시간을 입력해주세요."
                            maxlength="4"
                            v-model="selectTime"
                        />
                    </div>
                </div>

                <vs-divider color="danger">DC</vs-divider>
                <div class="vx-row mb-3">
                    <div class="vx-col w-full lg:w-1/1 justify-between">
                        <vs-checkbox v-model="dc">
                            DC
                        </vs-checkbox>
                        <template v-if="dc == true">
                            <vs-input v-model="dcMemo" placeholder="취소사유" class="mt-1 w-full" />
                        </template>
                    </div>
                </div>
                <template v-if="treatmentManagerModifiedList.length > 0">
                    <vs-divider color="danger">치료자</vs-divider>
                    <div class="vx-row mb-3">
                        <div class="vx-col lg:w-1/1 justify-between" v-for="(item, index) in treatmentManagerModifiedList" :key="index">
                            <input type="radio" class="mr-2" v-model="medicalManagers" :key="item.MANAGER_UID" :value="item.MANAGER_UID" />
                            <label :for="item.MANAGER_UID">{{ item.MANAGER_NAME }}</label>
                        </div>
                    </div>
                </template>
                <template v-if="treatmentDetailModifiedList.length > 0">
                    <vs-divider color="danger">스케줄</vs-divider>
                    <div class="vx-row mb-3">
                        <div class="vx-col lg:w-1/1 justify-between" v-for="(item, index) in treatmentDetailModifiedList" :key="index">
                            <input type="checkbox" class="mr-2" :id="item.DETAIL_NAME" v-model="medicalDetails" :value="item.DETAIL_SEQ" />
                            <label :for="item.DETAIL_NAME">{{ item.DETAIL_NAME }}</label>
                        </div>
                    </div>
                </template>

                <vs-divider color="danger">환자</vs-divider>
                <v-select :maxHeight="'50px'" v-model="selectedPatient" :closeOnSelect="true" :options="patientList" :dir="$vs.rtl ? 'rtl' : 'ltr'" />

                <vs-divider color="danger">메모</vs-divider>
                <div class="vx-row mb-3">
                    <div class="vx-col w-full lg:w-1/1">
                        <textarea id="memo" class="vs-component vs-con-textarea vs-textarea-primary" style="border: 1px solid rgba(0, 0, 0, 0.08);padding:20px;resize:none;"></textarea>
                    </div>
                </div>

                <div class="vx-row" style="margin-top:300px;">
                    <div class="vx-col w-full text-right">
                        <vs-button class="mr-3 mb-2" @click="saveSchedule">저장</vs-button>
                        <vs-button color="warning" type="border" class="mb-2" @click="popupClose">닫기</vs-button>
                    </div>
                </div>
            </form>
        </vs-popup> 
    </div>
</template>

<script>
import axiosClass from '@/../util/axiosClass';
import dateClass from '@/../util/dateClass';
import Datepicker from 'vuejs-datepicker';
import vSelect from 'vue-select';
import moment from 'moment';
import store from '@/store/store';
import { EventBus } from '../../../util/vue-event-bus';
import VacationRow from '@/components/vacation/VacationRow.vue';
import vacationService from '@/services/vacationService';
export default {
    components: {
        Datepicker,
        'v-select': vSelect,
        VacationRow,
    },
    data() {
        return {
            nowDate: '',
            prevDate: '',
            nextDate: '',
            nowDay:'',
            tabShowAll: true,
            dateList: [],
            timeList: [],
            tabList: [],
            treatmentData: [],
            treatmentCount: [],
            treatmentManagerList: [],
            treatmentManagerModifiedList: [],
            treatmentDetailList: [],
            treatmentDetailModifiedList: [],
            newCountList: [],
            copyChecked: [],
            popupActive: false,
            tabOptions: [],
            selectedTabOption:'',
            selectDate: '',
            selectTime:'',
            dc: '',
            dcMemo: '',
            medicalManagers: '',
            medicalDetails: [],
            selectedPatient:'',
            patientList: [],
            startDate: '',
            endDate: '',
            scheduleSeq: -1,
            deleteScheduleSeq: -1,
            activeTreatmentRoomId: '',


            medical_cd: '',
            time_index: -1,
            
            
            
            
            

            options: [],
            now_day: '',
            active: false,
            copy_schedule_seq: -1,
            copy_select_date: '',
            copy_select_time: '',
            memo: '',
            popupActive2: false,
            patientUsername: '',
            patientUid: '',
            patientAge: '',
            patientGender: '',
            medicalRoomNm: '',
            medicalRoomNumberNm: '',
            medicalName: '',
            sickNess: '',
            plan: '',
            chart_no: '',
            status_name: '',
            patient_phone: '',
            in_init_date: '',
            in_date: '',
            out_date: '',
            complate_yn: '',
            meal_name: '',
            medical_nm: '',
            west_medical_nm: '',
            protector_phone: '',
            schedule_seq: -1,
            dc: false,
            dc_memo: '',
            
            start_date: '',
            end_date: '',
            tab_options: [],


            loginUid: '',
            tab_sum: 0,

            width: window.innerWidth,

            // 연차 관련 데이터
            vacationMap: new Map(),
        };
    },
    methods: {
        handleResize(event) {
            this.width = window.innerWidth;
        },
        async init(date) {
            this.nowDay = dateClass.nowday();
            
            if (date == '') {
                this.nowDate = dateClass.dateYYYYMMDD();
            } else {
                this.nowDate = date;
            }

            this.$vs.loading({
                type: 'default',
                container: '#schedule',
                background: 'rgba(0,0,0,0.1)',
                color: 'primary',
                scale: 1.5,
            });
            // let jsonData = {
            //     uid: this.loginUid,
            // };
            const { data } = await axiosClass.get('/api/treatment/list/' + this.nowDate, {}, true);
            console.log('data:::', data);
            
            setTimeout(() => {
                this.$vs.loading.close('#schedule > .con-vs-loading');
            }, 100);
            
            
            // 메뉴 탭을 구성하는 로직
            this.tabList = [];
            
            for (let i = 0; i < data.tabList.length; i++) {
                if (data.tabList[i].TREATMENT_ROOM_ID != false) {
                    this.tabList.push(data.tabList[i]);
                }
            }

            // 스케쥴 등록 팝업의 환자 검색바를 구성하는 데이터
            this.patientList = [];
            
            for(let i = 0; i < data.patientList.length; i++) {
                // let tempStatus = data.patientList[i].STATUS_NAME == '' ? '미지정 / ' : data.patientList[i].STATUS_NAME + '/';
                let tempRoom = data.patientList[i].MEDICAL_ROOM_NUMBER_NM == '' ? '외래 /' : data.patientList[i].MEDICAL_ROOM_NUMBER_NM + '/';
                this.patientList.push({
                    id: data.patientList[i].PATIENT_UID,
                    label: tempRoom + data.patientList[i].PATIENT_USERNAME,
                });
            }

            // 스케쥴 등록 팝업의 치료실을 선택하는 로직
            this.tabOptions = [];

            for(let i = 0; i < this.tabList.length; i++){
                this.tabOptions.push({
                    id:this.tabList[i].TREATMENT_ROOM_ID,
                    label:this.tabList[i].TREATMENT_NAME
                })
            }

            // 날짜 관련 정보를 구성하는 로직
            this.dateList = [];

            for (let i = 0; i < data.dateList.length; i++) {
                this.dateList.push(data.dateList[i]);
            }

            this.startDate = this.dateList[0].YMD;
            this.endDate = this.dateList[this.dateList.length-1].YMD;

            this.prevDate = moment(this.startDate).add(-1, 'day').format('YYYY-MM-DD');
            
            this.nextDate = moment(this.endDate).add(1, 'day').format('YYYY-MM-DD');

            // 치료실 수를 구성하는 로직
            this.treatmentCount = [];

            for (let i = 0; i < data.treatmentCount.length; i++) {
                this.treatmentCount.push(data.treatmentCount[i]);
            }

            // 추가 / 미리 분배 후 배포하는 방식으로 구성
            this.newCountList = [];

            for(let i = 0 ; i < this.dateList.length; i++) {
                for(let j = 0 ; j < this.tabList.length; j++){
                    this.newCountList.push({
                        YMD: this.dateList[i].YMD,
                        TREATMENT_ROOM_ID : this.tabList[j].TREATMENT_ROOM_ID,
                        TREATMENT_NAME : this.tabList[j].TREATMENT_NAME,
                        TOTAL_COUNT : 0
                    })
                }
            }
            
            for(let i = 0 ; i < this.newCountList.length; i++ ) {
                for(let j = 0 ; j < this.treatmentCount.length; j++ ) {
                    if(this.newCountList[i].YMD == this.treatmentCount[j].YMD 
                        && this.newCountList[i].TREATMENT_ROOM_ID == this.treatmentCount[j].TREATMENT_ROOM_ID) {
                        this.newCountList[i].TOTAL_COUNT = this.treatmentCount[j].TOTAL_COUNT
                    } 
                }
            }
            
            //치료실담당자를 구성하는 로직
            this.treatmentManagerList = [];
            this.treatmentManagerList = data.treatmentManagerList;

            //치료실디테일을 구성하는 로직
            this.treatmentDetailList = [];
            this.treatmentDetailList = data.treatmentDetailList;

            // 시간정보를 구성하는 로직
            this.timeList = [];

            for(let i = 0 ; i < data.timeList.length ; i++) {
                if(i%2 == 0){   
                    this.timeList.push(data.timeList[i]);
                }
            }

            // 치료실 스케쥴을 구성하는 로직
            this.treatmentData = [];
            this.treatmentData = data.treatmentData;

            // 연차 정보 로드 (치료실 담당자 기준)
            await this.loadVacationData();

            let targetDate = dateClass.dateYYYYMMDD() || '';
            
            setTimeout(function() {
                var element = document.getElementById(targetDate.substring(0,4) + '-' + targetDate.substring(4,6) + '-' + targetDate.substring(6,8));
                element.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
            }, 500);
        },

        dayReturn(item) {
            const week = ['일', '월', '화', '수', '목', '금', '토'];
            const weekString = week[new Date(item).getDay()];

            return parseInt(item.substring(6, 8)) + '월 / ' + parseInt(item.substring(8, 10)) + '일(' + weekString + ')';
        },

        onClickMemberView (PatientUid) {
            this.$EventBus.$emit('memberView', PatientUid);
        },

        async popupOpen(day, time) {
            if(day == null || day == undefined) {
                day = '';
            }
            if(time == null || time == undefined) {
                time = '';
            }

            this.treatmentManagerModifiedList = [];
            this.treatmentDetailModifiedList = [];
            
            this.selectDate = day;
            this.selectTime = time;

            this.selectedTabOption = '';
            this.dc = '';
            this.dcMemo = '';
            this.medicalManagers = '';
            this.medicalDetails = [];
            this.selectedPatient = '';
            document.getElementById('memo').value = '';

            this.popupActive = true;
        },
        customFormatter(date) {
            return moment(date).format('YYYY-MM-DD');
        },

        prevMonth() {
            this.init(moment(this.prevDate).format('YYYYMMDD'));
        },

        nextMonth() {
            this.init(moment(this.nextDate).format('YYYYMMDD'));
        },

        popupClose(){
            this.selectedTabOption = '';
            this.selectDate = '';
            this.dc = '';
            this.dcMemo = '';
            this.medicalManagers = '';
            this.medicalDetails = [];
            this.selectedPatient = '';
            document.getElementById('memo').value = '';
            this.popupActive = false;
        },
        changeManagerDetailList () {
            
            this.treatmentManagerModifiedList = [];
            this.treatmentDetailModifiedList = [];

            for(let i = 0; i < this.treatmentManagerList.length; i ++) {
                if(this.treatmentManagerList[i].TREATMENT_ROOM_ID == this.selectedTabOption.id) {
                    this.treatmentManagerModifiedList.push(this.treatmentManagerList[i]);
                }
            }
            
            for(let i = 0; i < this.treatmentDetailList.length; i ++) {
                if(this.treatmentDetailList[i].TREATMENT_ROOM_ID == this.selectedTabOption.id) {
                    this.treatmentDetailModifiedList.push(this.treatmentDetailList[i]);
                }
            }

        },
        async saveSchedule() { 
            const memoValue = document.getElementById('memo').value;
            
            const params = {
                scheduleSeq : this.scheduleSeq,
                selectedTabOption : this.selectedTabOption.id,
                selectDate: moment(this.selectDate).format('YYYYMMDD'),
                selectTime: this.selectTime,
                dc : this.dc,
                dcMemo : this.dcMemo,
                memo : memoValue,
                medicalManagers : this.medicalManagers,
                medicalDetails : this.medicalDetails.join(),
                selectedPatient : this.selectedPatient.id,
            }
            console.log(params);
            const {data} = await axiosClass.post('/api/treatment/saveSchedule/', params, true);

            this.scheduleSeq = -1;
            console.log(data);
            this.popupActive = false;

            this.init('');

        },
        async viewSchedule (itemSequenceNumber) {
            
            const { data } = await axiosClass.get('/api/treatment/viewSchedule/' + itemSequenceNumber, {}, true);
            
            const scheduleData = data.scheduleData;
            
            console.log(scheduleData);            
            this.scheduleSeq = scheduleData.SCHEDULE_SEQ;
            this.selectedTabOption = '';

            for(let i = 0; i < this.tabOptions.length; i++) {
                if(scheduleData.MEDICAL_CODE == this.tabOptions[i].id) {
                    this.selectedTabOption = this.tabOptions[i];
                }
            }

            this.selectDate = '';
            this.selectDate = scheduleData.YMD_STRING == '' ? '' : moment(scheduleData.YMD_STRING).format('YYYY-MM-DD');

            this.selectTime = '';
            this.selectTime = scheduleData.REAL_TIME_STRING == '' ? '' : scheduleData.REAL_TIME_STRING;

            this.dcMemo = '';
            this.dcMemo = scheduleData.DC_MEMO == '' ? '' : scheduleData.DC_MEMO;

            if(this.dcMemo == null || this.dcMemo == '') {
                this.dc = false;
            } else {
                this.dc = true;
            }
            
            this.changeManagerDetailList();

            this.medicalManagers = '';
            this.medicalManagers = scheduleData.MEDICAL_MANAGERS == '' ? '' : scheduleData.MEDICAL_MANAGERS;

            this.medicalDetails = [];
            this.medicalDetails = scheduleData.MEDICAL_DETAILS == '' ? [] : scheduleData.MEDICAL_DETAILS.split(',');

            document.getElementById('memo').value = '';
            document.getElementById('memo').value = scheduleData.MEMO == '' ? '' : scheduleData.MEMO;
            
            for(let i =0; i < this.patientList.length; i++) { 
                if(this.patientList[i].id == scheduleData.PATIENT_UID) {
                    this.selectedPatient = this.patientList[i];
                }
            }

            this.popupActive = true;
        },
        async checkDeleteSchedule(item) {
            this.popupActive = false;
            this.deleteScheduleSeq = item.SCHEDULE_SEQ
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: '삭제',
                text: '예약된 치료실(' + item.TREATMENT_NAME + '-' + item.PATIENT_USERNAME + ')를 정말로 삭제하시겠습니까?',
                acceptText: '삭제',
                cancelText: '취소',
                accept: this.deleteSchedule,
            });
        },
        async deleteSchedule() {
            if (this.nowDate == '') {
                this.nowDate = dateClass.dateYYYYMM();
            }
            const jsonData = {
                scheduleSeq: this.deleteScheduleSeq,
            };
            
            const data =  await axiosClass.delete('/api/treatment/deleteSchedule', jsonData, true);
            
            setTimeout(() => {
                this.$vs.loading.close('#schedule > .con-vs-loading');
            }, 100);

            console.log(data);

            this.popupActive = false;

            this.$vs.notify({
                title: 'Success',
                text: '정상적으로 삭제되었습니다.',
                color: 'danger',
                position: 'top-right',
                iconPack: 'feather',
                icon: 'icon-check',
            });

            this.init('');
        },
        async tabClick(treatmentRoomId) {
            this.activeTreatmentRoomId = '';
            this.activeTreatmentRoomId = treatmentRoomId;

            if(treatmentRoomId == '') {
                return this.init(this.nowDate);
            }

            const params = {
                nowDate: this.nowDate,
                treatmentRoomId: treatmentRoomId,
            };
            
            this.$vs.loading({
                type: 'default',
                container: '#schedule',
                background: 'rgba(0,0,0,0.1)',
                color: 'primary',
                scale: 1.5,
            });
            const { data } = await axiosClass.get('/api/treatment/listByRoom', params, true);

            setTimeout(() => {
                this.$vs.loading.close('#schedule > .con-vs-loading');
            }, 100);

            this.treatmentData = data.treatmentData.length == 0 ? [] : data.treatmentData;

            // 연차 정보 다시 로드 (선택된 치료실 담당자 기준)
            await this.loadVacationData();

        },

        activeMenu(treatmentRoomId) {
            if (treatmentRoomId == this.activeTreatmentRoomId) {
                return 'activeMenu';
            } else {
                return '';
            }
        },

        /**
         * 연차 정보 로드 (치료실 담당자 기준)
         */
        async loadVacationData() {
            try {
                // 현재 선택된 치료실 담당자 또는 전체 담당자 UID 추출
                let managerUids = [];

                if (this.activeTreatmentRoomId) {
                    // 특정 치료실 선택 시 해당 치료실 담당자만
                    managerUids = this.treatmentManagerList
                        .filter(m => m.TREATMENT_ROOM_ID === this.activeTreatmentRoomId)
                        .map(m => m.MANAGER_UID);
                } else {
                    // 전체 선택 시 모든 담당자
                    managerUids = this.treatmentManagerList.map(m => m.MANAGER_UID);
                }

                if (managerUids.length === 0) {
                    this.vacationMap = new Map();
                    return;
                }

                // 날짜 범위 변환 (YYYY-MM-DD 형식)
                const formattedStartDate = this.startDate;
                const formattedEndDate = this.endDate;

                this.vacationMap = await vacationService.getVacationsByManagers(
                    formattedStartDate,
                    formattedEndDate,
                    managerUids
                );
            } catch (error) {
                console.error('연차 정보 로드 실패:', error);
                this.vacationMap = new Map();
            }
        },

        /**
         * VacationRow용 날짜 키 포맷 함수
         */
        formatDateKeyForVacation(dateItem) {
            if (typeof dateItem === 'string') {
                return dateItem.replace(/-/g, '');
            }
            if (dateItem && dateItem.YMD) {
                return dateItem.YMD.replace(/-/g, '');
            }
            return '';
        },

        styleReturn(treatmentName) {
            let btnColor = '';
            if (treatmentName == '고주파실') {
                btnColor = 'background-color:rgba(128,175,178, 0.3);';
            } else if (treatmentName == '물리치료실' || treatmentName == '물리치료') {
                btnColor = 'background-color:rgba(150,180,214, 0.3);';
            } else if (treatmentName == '주열실') {
                btnColor = 'background-color:rgba(201,149,164, 0.3);';
            } else if (treatmentName == '한의과 침치료'  || treatmentName == '한방 외래치료') {
                btnColor = 'background-color:rgba(196,164,148, 0.3);';
            } else if (treatmentName == '마사지실') {
                btnColor = 'background-color:rgba(224,227,154,0.3);';
            } else if (treatmentName == '산소챔버') {
                btnColor = 'background-color:rgba(185,232,239,0.3);';
            } else if (treatmentName == '온열실') {
                btnColor = 'background-color:rgba(204,216,195,0.3);';
            } else if (treatmentName == '외래주사실' || treatmentName == '면역주사실') {
                btnColor = 'background-color:rgba(179,167,206, 0.3);';
            } else {
                btnColor = 'background-color:rgba(226,164,147,0.3);';
            }
            return btnColor;
        },
        // async curePlan(schedule_seq) {
        //     // console.log(schedule_seq);
        //     const { data } = await axiosClass.post('/api/cure/select/' + schedule_seq, {}, true);
        //     // console.log(data.cure_plan['PATIENT_USERNAME']);
        //     if (data.cure_plan['PLAN'] == '') {
        //         data.cure_plan['PLAN'] = '없음';
        //     }
        //     this.popupActive = false;
        //     let _this = this;
        //     _this.$vs.dialog({
        //         color: 'primary',
        //         title: data.cure_plan['PATIENT_USERNAME'] + '님 치료플랜',
        //         text: data.cure_plan['PLAN'],
        //         acceptText: '닫기',
        //     });
        // },
        // async memberReport(uid) {
        //     const { data } = await axiosClass.get('/api/remote/userData/' + uid, {}, true);
        //     // console.log(uid);
        //     // console.log(data);
        //     this.popupActive2 = true;
        //     this.patientUsername = data.patientData.PATIENT_USERNAME;
        //     this.patientAge = data.patientData.PATIENT_AGE;
        //     this.patientGender = data.patientData.PATIENT_GENDER_CONVERT;
        //     this.medicalRoomNm = data.patientData.MEDICAL_ROOM_NM;
        //     this.medicalRoomNumberNm = data.patientData.MEDICAL_ROOM_NUMBER_NM;
        //     this.medicalName = data.patientData.MEDICAL_NAME;
        //     this.sickNess = data.patientData.SICKNESS;
        //     this.plan = data.patientData.PLAN;
        //     this.memo = data.patientData.MEMO;
        //     this.chart_no = data.patientData.CHART_NO;
        //     this.status_name = data.patientData.STATUS_NAME;
        //     this.patient_phone = data.patientData.PATIENT_PHONE;
        //     this.in_init_date = data.patientData.IN_INIT_DATE;
        //     this.in_date = data.patientData.IN_DATE;
        //     this.out_date = data.patientData.OUT_DATE;
        //     this.complate_yn = data.patientData.COMPLATE_YN;
        //     this.meal_name = data.patientData.MEAL_NAME;
        //     this.medical_nm = data.patientData.MEDICAL_NM;
        //     d;
        //     this.west_medical_nm = data.patientData.WEST_MEDICAL_NAME;
        //     this.protector_phone = data.patientData.PROTECTOR_PHONE;
        //     // console.log(data);
        // },
        // popupClose() {
        //     this.popupActive = false;
        // },


        

        
        
    },
    mounted() {
        window.addEventListener('resize', this.handleResize);
        this.loginUid = store.getters.getUID;
        this.init('');
        EventBus.$on('remoteListRefresh', async () => {
        this.init('');
        });
        EventBus.$on('remoteListCsRefresh', async () => {
        this.init('');
        });
    },

    computed: {
        // nowDate() {
        //     return this.now_date.substring(0, 4) + '년 ' + this.now_date.substring(4, 6) + '월';
        // },
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },
};

window.addEventListener('resize', reportWindowSize);
window.addEventListener('load', reportWindowSize);
function reportWindowSize() {
//     document.getElementById('calendarDiv').style.height = document.documentElement.clientHeight - 500 + 'px';
}
</script>

<style>
.calendar tbody tr td {
    padding: 10px;
}

.includeIcon {
    display: initial;
}

.con-vs-chip {
    min-height: 40px;
}

.vs-chip--text {
    font-size: 0.9rem;
}

.activeMenu {
    border-color: #015666;
}

.display-time {
    padding: 0.7rem;
    border-radius: 5px;
    border: 1px solid rgba(0, 0, 0, 0.2);
}
table > thead > tr > th {
    font-weight: 400;
    background-color: blue;
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
    z-index: 1;
}
table > tbody > tr > td {
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}
.tb_box {
    overflow: auto;
}
.table_header {
    position: sticky;
    top: 0;
}

.selectOn {
    border: 3px solid #439798;
    color: #fff;
}

.selectOff {
    border: 0px;
    color: #fff;
}
.contentTable {
    font-size: 12px;
}
.headerBtn {
    background-color: rgba(241, 241, 241, 0.9);
    padding: 5px 10px;
}
.headerBtn a {
    padding: 5px;
}

.timeHeader {
    position: sticky;
    left: 0;
    z-index: 999;
}
</style>